import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { LocalizedProperty, lt } from '@mews/framework';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { PaymentLinkDetailItem } from './PaymentLinkDetailItem';

export const ServiceOrderNumberInfoRow = ({ serviceOrderId }: { serviceOrderId: string }) => {
    const enterpriseId = useCurrentEnterpriseId();
    const { data: { services = [] } = {} } = useRepositorySuspenseQuery('services', 'getAll', {
        enterpriseIds: [enterpriseId],
    });
    const { data: serviceOrder } = useRepositorySuspenseQuery(
        'reservations',
        'getAll',
        {
            reservationIds: [serviceOrderId],
        },
        { select: (data) => data.reservations?.[0] }
    );

    if (!serviceOrder) {
        return null;
    }

    const service = services.find((s) => s.id === serviceOrder.serviceId);
    const reservationNumber = service ? (
        <span>
            <LocalizedProperty property={service.names} /> {serviceOrder.number}
        </span>
    ) : (
        serviceOrder.number
    );

    return <PaymentLinkDetailItem description={lt('ReservationNumber')} value={reservationNumber} />;
};
